/**
 * Типы лейаутов
 */
export const enum LayoutTypes
{
    LAYOUT_DEFAULT = 'default-layout',
    LAYOUT_TABLE = 'table-layout',
    LAYOUT_TASK = 'task-layout',
    LAYOUT_SEAT = 'seat-layout',
    LAYOUT_SEAT_ON_TABLE = 'seat-on-table',
}
